module.exports = __webpack_public_path__ + "img/PVP_CeltTechRam_Upgrade2_ua.cd12e051.webp";